/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStammdatenDto } from '../../models/lexplus-stammdaten-dto';
import { LexplusStammdatenTyp } from '../../models/lexplus-stammdaten-typ';

export interface StammdatenControllerFindOneV1$Params {
  id: number;
  typ: LexplusStammdatenTyp;
}

export function stammdatenControllerFindOneV1(http: HttpClient, rootUrl: string, params: StammdatenControllerFindOneV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusStammdatenDto>> {
  const rb = new RequestBuilder(rootUrl, stammdatenControllerFindOneV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('typ', params.typ, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusStammdatenDto>;
    })
  );
}

stammdatenControllerFindOneV1.PATH = '/v1/stammdaten/{typ}/{id}';
